import {
  mapStructureByCompType,
  mapStructureById,
  replaceTextMarqeeImage,
  replaceVectorArt,
} from '../utils';
import {
  isFieldContentRole,
  PresetContentFieldRole,
} from '@wix/editor-content-injector';

import type {
  KitDefinition,
  KitPresetStructures,
  KitVectorArtDefinition,
} from '../types';
import type {
  FieldContentRole,
  SerializedCompStructure,
} from '@wix/document-services-types';

export const setSectionIcons = (
  { structure, mobileStructure }: KitPresetStructures,
  kitIcons: KitDefinition['icons'],
): void => {
  if (!kitIcons?.length) return;
  let iconIndex = 0;
  const mobileStructureById = mapStructureById(mobileStructure);
  const structureByCompTypeEntry = mapStructureByCompType(structure);
  const processStructures = (
    compType: string,
    replaceFunction: (
      structure: SerializedCompStructure,
      icon: KitVectorArtDefinition,
    ) => void,
  ) => {
    const structures = structureByCompTypeEntry[compType];
    structures?.forEach((vectorArtStructure) => {
      const { id, contentRole } = vectorArtStructure;
      if (
        id &&
        contentRole &&
        isFieldContentRole(contentRole) &&
        (contentRole as FieldContentRole).fieldRole ===
          PresetContentFieldRole.Icon
      ) {
        const icon = kitIcons[iconIndex];
        replaceFunction(vectorArtStructure, icon);
        const mobileIconStructure = mobileStructureById[id];
        if (mobileIconStructure) {
          replaceFunction(mobileIconStructure, icon);
        }
        iconIndex = (iconIndex + 1) % kitIcons.length;
      }
    });
  };

  processStructures('wysiwyg.viewer.components.VectorImage', replaceVectorArt);
  processStructures('wixui.TextMarquee', replaceTextMarqeeImage);
};
